module.exports = __webpack_public_path__ + "static/img/NewsImage4.68173b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/news/NewsImage4.png
// module id = aYwl
// module chunks = 1